(function ($) {
    /// <summary>
    /// This object provides a plugin with different visuals for editing and assigning tags <br/>
    /// An html div gets extracted with a header menu, an edit div and the click event handler.<br/>
    /// The instanciation in js:<br/>
    /// $("myTags").vcTagManager();<br/>
    /// Change the default height  by the following option: <br/>
    /// $(".vc-myTags").vcTagManager({h:500});<br/>
    /// <br/>
    /// Author: AFU<br />
    /// Date: 12.1.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.1.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

  
    var helper = {
        // <summary>
        // Helper function with click handler events
        // </summary>

        initEvents: function () {
            var visual = new vcVisual();
            var vcC = new vcCommon();

            $.fn.vcTagManager.obj.find(".note").html(window._RESOURCES.JS_Com.tagManagerHelp2_lbl);
            visual.addVisualBaseByName($.fn.vcTagManager.editPrefix, 'VISUAL_FORM_TAGS', $.fn.vcTagManager.vcgid, getCurrentTimestamp(), parseInt(helper.getDivEdit().height(), 10), 950, "true", $.fn.vcTagManager.settings.LoggerId, 1);

            $.fn.vcTagManager.obj.find(".menu").button().on("click", function () {
               
                $.fn.vcTagManager.obj.find(".menu").removeClass("button-toggle-active");
                $(this).addClass("button-toggle-active");
                var type = $(this).attr("data-type");
               
                helper.getDivEdit().html(vcC.getLoadingIcon());
                switch (type) {
                    case "allSignals2Tags":
                        $.fn.vcTagManager.obj.find(".note").html(window._RESOURCES.JS_Com.tagManagerHelp0_lbl);
                        visual.addVisualBaseByName($.fn.vcTagManager.editPrefix, 'VISUAL_TAGS_ASSIGNMENT_ALLSIGNALS2TAGS', $.fn.vcTagManager.vcgid, getCurrentTimestamp(), parseInt(helper.getDivEdit().height(), 10), $.fn.vcTagManager.settings.w - 10, JSON.stringify($.fn.vcTagManager.settings.ShowCalculations), $.fn.vcTagManager.settings.LoggerId, 1);
                        break;
                    case "allTags2Signals":
                        $.fn.vcTagManager.obj.find(".note").html(window._RESOURCES.JS_Com.tagManagerHelp1_lbl);
                        visual.addVisualBaseByName($.fn.vcTagManager.editPrefix, 'VISUAL_TAGS_ASSIGNMENT_ALLTAGS2SIGNALS', $.fn.vcTagManager.vcgid, getCurrentTimestamp(), parseInt(helper.getDivEdit().height(), 10), $.fn.vcTagManager.settings.w - 10, JSON.stringify($.fn.vcTagManager.settings.ShowCalculations), $.fn.vcTagManager.settings.LoggerId, 1);
                        break;
                    case "tags":
                        $.fn.vcTagManager.obj.find(".note").html(window._RESOURCES.JS_Com.tagManagerHelp2_lbl);
                        visual.addVisualBaseByName($.fn.vcTagManager.editPrefix, 'VISUAL_FORM_TAGS', $.fn.vcTagManager.vcgid, getCurrentTimestamp(), parseInt(helper.getDivEdit().height(), 10), 950, "true", $.fn.vcTagManager.settings.LoggerId, 1);
                        break;
                }
            });

        },
        // <summary>
        // Helper functions which returns the edit div object
        // </summary>
        getDivEdit: function () {
            return $.fn.vcTagManager.obj.find("#" + $.fn.vcTagManager.editPrefix + '' + $.fn.vcTagManager.vcgid);
        }
        };

    // <summary>
    // public functions  
    // </summary>
    var methods = {
     
        //inits all steps
        init: function (options) {
            var me = $(this);
           
            $.fn.vcTagManager.obj = me;
            //merge optional settings with the default settings
            $.fn.vcTagManager.settings = $.extend({}, $.fn.vcTagManager.defaultSettings, options);
            var h = $.fn.vcTagManager.settings.h;
           
            if (me.hasClass("vc-tag-manager") === false) { me.addClass("vc-tag-manager"); }

            $.fn.vcTagManager.vcgid = parseInt(Math.random() * 1000000,10);

            var sTmp = "<div data-type='tags' class='menu button-toggle button-toggle button-toggle-active'>" + window._RESOURCES.JS_Com.editTags_lbl + "</div>";
            sTmp += "<div data-type='allSignals2Tags' class='menu button-toggle '>" + window._RESOURCES.JS_Com.assignSignals2Tags_lbl + "</div>";
            sTmp += "<div data-type='allTags2Signals' class='menu button-toggle button-toggle'>" + window._RESOURCES.JS_Com.assignTags2Signals_lbl + "</div>";
            sTmp += "<hr/>";
            sTmp += "<div class='note'></div>";

            sTmp += "<div id='" + $.fn.vcTagManager.editPrefix + '' + $.fn.vcTagManager.vcgid + "'  style='width: 100%;margin-top:10px;h'></div>";
            sTmp += "<div style='clear: both'></div>";      
            me.html(sTmp);
            h -= 85 ;
            $.fn.vcTagManager.obj.find("#" + $.fn.vcTagManager.editPrefix + '' + $.fn.vcTagManager.vcgid).height(h);
            helper.initEvents();
            return this;
        }
    }

    //instantiates the new plugin and decides if the given arguments are options or methods
    $.fn.vcTagManager = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist');
        }
        return this;
    };

    //settings object of the current instance
    $.fn.vcTagManager.settings = {};
    //step object list of the current instance
    $.fn.vcTagManager.obj = null;
    //prefix of the edit div name
    $.fn.vcTagManager.editPrefix = "divEdit";
    //random vcgid
    $.fn.vcTagManager.vcgid = "";
    //default settings of the current instance
    $.fn.vcTagManager.defaultSettings = { h:640, w:1260, ShowCalculations:false, LoggerId:-1 };
})(jQuery);